import helpService from '../services/HelpService';

export default {

    state: {
        title: '...',
        body: '...',
        visible: false,
        editable: true,
        editing: false,
        codename: '',
        modozatid: null,
        mezo: '',
        idhelp: 0,
    },

    getters: {
        isHelpVisible: (state) => state.visible,

        isHelpEditable: (state) => state.editable,

        title: (state) => state.title,

        body: (state) => state.body,

        editing: (state) => state.editing,

        mezo: (state) => state.mezo,

        visible: (state) => state.visible,
    },

    mutations: {
        /* eslint-disable no-param-reassign */
        setHelp: (state, help) => {
            state.title = help.cimsor;
            state.body = help.leiras;
            state.mezo = help.mezo;
            state.idhelp = help.idhelp;
            state.modozatid = help.idmodozat;
        },

        finishEditing: (state) => {
            state.editing = false;
        },

        startEditing: (state) => {
            state.editing = true;
        },

        setTitle: (state, title) => {
            state.title = title;
        },

        setBody: (state, body) => {
            state.body = body;
        },

        setModozat: (state, modozat) => {
            state.idmodozat = parseInt(modozat, 10);
        },

        setCodeName: (state, codename) => {
            state.codename = codename;
        },

        setMezo: (state, mezo) => {
            state.mezo = mezo;
        },

        setIdHelp: (state, idhelp) => {
            state.idhelp = idhelp;
        },
        showHelp: (state) => {
            state.visible = true;
        },
        hideHelp: (state) => {
            state.visible = false;
        },
        /* eslint-enable no-param-reassign */
    },

    actions: {
        updateHelp: (context) => {
            helpService.getHelpByName(
                context.state.mezo,
                context.state.codename,
            ).then((response) => {
                if (response.data.mezo) {
                    context.commit('setHelp', response.data);
                } else {
                    context.commit('setHelp', {
                        idhelp: 0,
                        mezo: context.state.mezo,
                        codename: context.state.codename,
                        title: '',
                        modozat: 0,
                        body: '',
                    });
                }
            });
        },

        saveHelp: (context) => {
            helpService.saveItem(
                context.state.idhelp,
                context.state.title,
                context.state.body,
                context.state.mezo,
                context.state.codename,
                context.state.idmodozat,
            ).then(() => {
                context.commit('finishEditing');
            });
        },

        editHelp: (context) => {
            context.commit('startEditing');
        },
    },

};
